import { getAll, get } from '@/api/produit/produitLocation';
import { NO_PAGINATION } from '@/configuration/clientTableConf';
import { getIdSocieteHolding, siteHasHolding } from '@/services/general/holding';

async function getProduitLocWithHoldingMode(produitParDefautId, societeId) {
  const locDefaut = (await get(produitParDefautId)).data.result;
  if (locDefaut.supportCommercial.societeId === societeId) return locDefaut;
  if (!locDefaut.produitLocation.holdingProduitId && societeId !== getIdSocieteHolding()) {
    return locDefaut;
  }
  if (societeId === getIdSocieteHolding()) {
    const loc = (await get(locDefaut.produitLocation.holdingProduitId)).data.result;
    return loc;
  }
  const params = {
    query: {
      holdingProduitId: locDefaut.produitLocation.holdingProduitId,
      societeId: societeId,
    },
    limit: NO_PAGINATION,
  };
  const allProduits = (await getAll(params)).data.result.items;
  return allProduits.length > 0 ? allProduits[0] : null;
}

export default async function getProduitLocDefaut(
  produitsLocation, societeIdProduitFace, produitParDefautId, societeActiveId,
) {
  let location = null;
  if (!siteHasHolding() || societeActiveId === societeIdProduitFace) {
    location = produitsLocation.find((produitLocation) => {
      return produitLocation.id === produitParDefautId;
    });
  }
  if (!location && siteHasHolding()) {
    location = await getProduitLocWithHoldingMode(produitParDefautId, societeActiveId);
  }
  return location;
}
